/* istanbul ignore file */

import React from "react";
import { bedragFormatNull } from "../infra/scenario-utils";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";

export interface BenodigdKapitaalTableProps {
  benodigdKapitaal: number | null;
  benodigdKapitaalOmschrijving: string;
}

export const BenodigdKapitaalTable: React.FC<BenodigdKapitaalTableProps> = ({
  benodigdKapitaal,
  benodigdKapitaalOmschrijving,
}: BenodigdKapitaalTableProps) => {
  const data = [
    {
      omschrijving: benodigdKapitaalOmschrijving,
      bedrag: bedragFormatNull(benodigdKapitaal),
    },
  ];

  const columns: Column[] = [
    {
      header: "Uw risico o.b.v. uw gewenste inkomen",
      accessor: "bedrag",
    },
  ];

  return (
    <Table
      columns={columns}
      data={data}
      rotate
      id="benodigd-kapitaal-table"
      className="scenario__table mb-4 table table-striped table-bordered table-hover table-responsive"
    />
  );
};
